import { IUserTimeOffs } from '@tsin-core/states/staff/staff';
import { TimeOffInput } from './interface';

export class GetAllRequests {
    static readonly type = '[TimeOff] all';
    constructor(
        public queryParams?: {
            formTitle?: string;
        }
    ) {}
}

export class CreateTimeOff {
    static readonly type = '[TimeOff] create time-off';
    constructor(public input: TimeOffInput) {}
}

export class GetSingleTimeOff {
    static readonly type = '[TimeOff] get-one';
    constructor(public id: string) {}
}
export class GetTimeOffsByUser {
    static readonly type = '[TimeOff] get-by-user';
    constructor(public input: { id: string; query: string }) {}
}
export class GetTimeOffsByApprovers {
    static readonly type = '[TimeOff] approvers';
    constructor(public input: { id: string; query: string }) {}
}
